import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  slot: "primary"
}
const _hoisted_2 = {
  key: 1,
  slot: "secondary"
}

import { IonBackButton, IonButtons, IonTitle, IonToolbar, useIonRouter } from "@ionic/vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { CustomHeaderProps } from "@/types/props"

import { chevronBack } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomHeader',
  props: {
    backButton: { type: Boolean },
    color: { default: ION_VARIANT.PURPLE },
    empty: { type: Boolean },
    title: {},
    defaultHref: {},
    fixedRoute: {},
    forceBackground: { type: Boolean },
    noAnimation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const { navigate } = useIonRouter()

const routeBackFixed = (): void => {
    navigate(props.fixedRoute, props.noAnimation ? 'none' : 'back', 'pop')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonToolbar), {
    class: _normalizeClass(["custom-toolbar ion-background-purple-background", {'remove-border no-height': __props.empty}])
  }, {
    default: _withCtx(() => [
      (!__props.empty)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(IonButtons), {
              slot: "start",
              collapse: ""
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "start", {}, () => [
                  (__props.backButton)
                    ? (_openBlock(), _createBlock(_unref(IonBackButton), {
                        key: 0,
                        icon: _unref(chevronBack),
                        text: _ctx.$t('button.back'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.fixedRoute ? routeBackFixed() : _ctx.$router.back())),
                        class: "force-color custom-back-button resize-back-button",
                        "default-href": __props.defaultHref ?? '/home'
                      }, null, 8, ["icon", "text", "default-href"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 3
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString(__props.title ?? _ctx.$route.meta?.title ?? 'Octopus'), 1)
                ])
              ]),
              _: 3
            }),
            _createVNode(_unref(IonButtons), {
              slot: "end",
              collapse: ""
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "end")
              ]),
              _: 3
            }),
            (_ctx.$slots['primary'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "primary")
                ]))
              : _createCommentVNode("", true),
            (_ctx.$slots['secondary'])
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "secondary")
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})